import { useQuery } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";

/**
 * Hook for fetching headings based on related questions
 */
export const useGetHeadings = (related_questions: string[]) => {
  return useQuery({
    queryKey: ["headings", related_questions],
    queryFn: () => requestCategoryService.getHeadings({ related_questions }),
    enabled: related_questions.length > 0,
  });
};
